import React, { useState, useCallback, useEffect } from "react";
import LoginForm from "./LoginForm";
import SignUpForm from "./SignUpForm";
import OtpForm from "./OtpForm";

const AuthForm = ({
  onLogin,
  defaultLogin,
  onBack = null,
  activateBackButton = null,
  chatLogin = "",
  fromChat = false,
}) => {
  useEffect(() => {
    if (activateBackButton && onBack) {
      activateBackButton(true, () => {
        onBack?.();
      });
    }
  }, []);

  defaultLogin = defaultLogin ? true : false;

  const [showLogin, setShowLogin] = useState(defaultLogin);
  const [tokenType, setTokenType] = useState(null);
  const [target, setTarget] = useState(null);
  const [token, setToken] = useState(null);
  const [otpData, setOtpData] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [signUpData, setSignUpData] = useState(null);

  const handleLoginSuccess = (
    tokenType,
    sessionId,
    token,
    user,
    otpData,
    target
  ) => {
    setTokenType(tokenType);
    setSessionId(sessionId);
    setToken(token);
    if (tokenType === "otp") {
      setOtpData(otpData);
    }
    if (target) {
      setTarget(target);
    }
    setShowLogin(false); // Switch to OTP form if needed
    if (onLogin && user) {
      onLogin(user);
    }
  };

  const handleBackButtonClick = useCallback(
    (tokenType) => {
      setTokenType(tokenType);
      if (tokenType === "otp") {
        setShowLogin(target === "login"); // Return to login or sign-up based on target
      } else {
        onBack?.(); // Return to cart
      }
    },
    [target, onBack]
  );
  return (
    <div className={`auth-form ${chatLogin}`}>
      {tokenType === "otp" ? (
        <OtpForm
          sessionId={sessionId}
          token={token}
          otpData={otpData}
          signUpData={signUpData}
          onBack={handleBackButtonClick}
          onLoginSuccess={handleLoginSuccess}
          target={target}
        />
      ) : (
        <>
          {showLogin ? (
            <LoginForm
              onBack={onBack}
              setShowLogin={setShowLogin}
              onLoginSuccess={handleLoginSuccess}
              fromChat={fromChat}
            />
          ) : (
            <SignUpForm
              setShowLogin={setShowLogin}
              onLoginSuccess={handleLoginSuccess}
              setTokenType={setTokenType}
              setSessionId={setSessionId}
              setToken={setToken}
              setOtpData={setOtpData}
              setSignUpData={setSignUpData}
              setTarget={setTarget}
              fromChat={fromChat}
            />
          )}
        </>
      )}
    </div>
  );
};

export default AuthForm;
